const Arrive = function (s, e, u) {
  "use strict";
  if (s.MutationObserver && "undefined" != typeof HTMLElement) {
    var n, t, r = 0,
        d = (n = HTMLElement.prototype.matches || HTMLElement.prototype.webkitMatchesSelector || HTMLElement.prototype.mozMatchesSelector || HTMLElement.prototype.msMatchesSelector, {
          matchesSelector: function (e, t) {
            return e instanceof HTMLElement && n.call(e, t)
          },
          addMethod: function (e, t, n) {
            var r = e[t];
            e[t] = function () {
              return n.length == arguments.length ? n.apply(this, arguments) : "function" == typeof r ? r.apply(this, arguments) : void 0
            }
          },
          callCallbacks: function (e, t) {
            t && t.options.onceOnly && 1 == t.firedElems.length && (e = [e[0]]);
            for (var n, r = 0; n = e[r]; r++) n && n.callback && n.callback.call(n.elem, n.elem);
            t && t.options.onceOnly && 1 == t.firedElems.length && t.me.unbindEventWithSelectorAndCallback.call(t.target, t.selector, t.callback)
          },
          checkChildNodesRecursively: function (e, t, n, r) {
            for (var i, o = 0; i = e[o]; o++) n(i, t, r) && r.push({
              callback: t.callback,
              elem: i
            }), 0 < i.childNodes.length && d.checkChildNodesRecursively(i.childNodes, t, n, r)
          },
          mergeArrays: function (e, t) {
            var n, r = {};
            for (n in e) e.hasOwnProperty(n) && (r[n] = e[n]);
            for (n in t) t.hasOwnProperty(n) && (r[n] = t[n]);
            return r
          },
          toElementsArray: function (e) {
            return void 0 === e || "number" == typeof e.length && e !== s || (e = [e]), e
          }
        }),
        f = ((t = function () {
          this._eventsBucket = [], this._beforeAdding = null, this._beforeRemoving = null
        }).prototype.addEvent = function (e, t, n, r) {
          var i = {
            target: e,
            selector: t,
            options: n,
            callback: r,
            firedElems: []
          };
          return this._beforeAdding && this._beforeAdding(i), this._eventsBucket.push(i), i
        }, t.prototype.removeEvent = function (e) {
          for (var t, n = this._eventsBucket.length - 1; t = this._eventsBucket[n]; n--)
            if (e(t)) {
              this._beforeRemoving && this._beforeRemoving(t);
              var r = this._eventsBucket.splice(n, 1);
              r && r.length && (r[0].callback = null)
            }
        }, t.prototype.beforeAdding = function (e) {
          this._beforeAdding = e
        }, t.prototype.beforeRemoving = function (e) {
          this._beforeRemoving = e
        }, t),
        l = function (i, o) {
          var l = new f,
              c = this,
              a = {
                fireOnAttributesModification: !1
              };
          return l.beforeAdding(function (t) {
            var e, n = t.target;
            n !== s.document && n !== s || (n = document.getElementsByTagName("html")[0]), e = new MutationObserver(function (e) {
              o.call(this, e, t)
            });
            var r = i(t.options);
            e.observe(n, r), t.observer = e, t.me = c
          }), l.beforeRemoving(function (e) {
            e.observer.disconnect()
          }), this.bindEvent = function (e, t, n) {
            t = d.mergeArrays(a, t);
            for (var r = d.toElementsArray(this), i = 0; i < r.length; i++) l.addEvent(r[i], e, t, n)
          }, this.unbindEvent = function () {
            var n = d.toElementsArray(this);
            l.removeEvent(function (e) {
              for (var t = 0; t < n.length; t++)
                if (this === u || e.target === n[t]) return !0;
              return !1
            })
          }, this.unbindEventWithSelectorOrCallback = function (n) {
            var e, r = d.toElementsArray(this),
                i = n;
            e = "function" == typeof n ? function (e) {
              for (var t = 0; t < r.length; t++)
                if ((this === u || e.target === r[t]) && e.callback === i) return !0;
              return !1
            } : function (e) {
              for (var t = 0; t < r.length; t++)
                if ((this === u || e.target === r[t]) && e.selector === n) return !0;
              return !1
            }, l.removeEvent(e)
          }, this.unbindEventWithSelectorAndCallback = function (n, r) {
            var i = d.toElementsArray(this);
            l.removeEvent(function (e) {
              for (var t = 0; t < i.length; t++)
                if ((this === u || e.target === i[t]) && e.selector === n && e.callback === r) return !0;
              return !1
            })
          }, this
        },
        i = new function () {
          var a = {
            fireOnAttributesModification: !1,
            onceOnly: !1,
            existing: !1
          };

          function o(e, t, n) {
            return !(!d.matchesSelector(e, t.selector) || (e._id === u && (e._id = r++), -1 != t.firedElems.indexOf(e._id)) || (t.firedElems.push(e._id), 0))
          }

          var s = (i = new l(function (e) {
            var t = {
              attributes: !1,
              childList: !0,
              subtree: !0
            };
            return e.fireOnAttributesModification && (t.attributes = !0), t
          }, function (e, i) {
            e.forEach(function (e) {
              var t = e.addedNodes,
                  n = e.target,
                  r = [];
              null !== t && 0 < t.length ? d.checkChildNodesRecursively(t, i, o, r) : "attributes" === e.type && o(n, i) && r.push({
                callback: i.callback,
                elem: n
              }), d.callCallbacks(r, i)
            })
          })).bindEvent;
          return i.bindEvent = function (e, t, n) {
            void 0 === n ? (n = t, t = a) : t = d.mergeArrays(a, t);
            var r = d.toElementsArray(this);
            if (t.existing) {
              for (var i = [], o = 0; o < r.length; o++)
                for (var l = r[o].querySelectorAll(e), c = 0; c < l.length; c++) i.push({
                  callback: n,
                  elem: l[c]
                });
              if (t.onceOnly && i.length) return n.call(i[0].elem, i[0].elem);
              setTimeout(d.callCallbacks, 1, i)
            }
            s.call(this, e, t, n)
          }, i
        },
        c = new function () {
          var r = {};

          function i(e, t) {
            return d.matchesSelector(e, t.selector)
          }

          var o = (c = new l(function () {
            return {
              childList: !0,
              subtree: !0
            }
          }, function (e, r) {
            e.forEach(function (e) {
              var t = e.removedNodes,
                  n = [];
              null !== t && 0 < t.length && d.checkChildNodesRecursively(t, r, i, n), d.callCallbacks(n, r)
            })
          })).bindEvent;
          return c.bindEvent = function (e, t, n) {
            void 0 === n ? (n = t, t = r) : t = d.mergeArrays(r, t), o.call(this, e, t, n)
          }, c
        };
    e && h(e.fn), h(HTMLElement.prototype), h(NodeList.prototype), h(HTMLCollection.prototype), h(HTMLDocument.prototype), h(Window.prototype);
    var o = {};
    return a(i, o, "unbindAllArrive"), a(c, o, "unbindAllLeave"), o
  }

  function a(e, t, n) {
    d.addMethod(t, n, e.unbindEvent), d.addMethod(t, n, e.unbindEventWithSelectorOrCallback), d.addMethod(t, n, e.unbindEventWithSelectorAndCallback)
  }

  function h(e) {
    e.arrive = i.bindEvent, a(i, e, "unbindArrive"), e.leave = c.bindEvent, a(c, e, "unbindLeave")
  }
}(window, "undefined" == typeof jQuery ? null : jQuery, void 0);